import React from "react";
import cx from "classnames";
import WarningBanner from "Components/warningBanner/WarningBanner";
import TranslatedString from "Components/TranslatedString";

export default ({ forcedNotAvailable, forcedMsg, currentPlan, notAvailableFor = [], children }) => {
  const notAvailable = forcedNotAvailable || notAvailableFor.includes(currentPlan);
  let msg;

  if (forcedMsg) {
    msg = forcedMsg;
  } else if (notAvailableFor.includes("professional")) {
    msg = "infoMsg.planAlert.noProfessional";
  } else if (notAvailableFor.includes("basic")) {
    msg = "infoMsg.planAlert.noBasic";
  }

  return (
    <div
      className={cx("inputFull2 boxSP", {
        notAvailableSP: notAvailable,
      })}
    >
      {notAvailable && (
        <div className="inputFull2">
          <WarningBanner info color="blue" msg={<TranslatedString>{msg}</TranslatedString>} />
        </div>
      )}
      {children}
    </div>
  );
};
